import { OpportunitySchema } from '@features/opportunities/modules/core/models/schema-property-definition';
import { StringPropertyDefinition } from '@shared/models/schema-property-definition';
import { DatesUtil } from '@shared/utilities/dates/dates.util';

export namespace DiaryNote {
  export type Definition =
    | ({ type: 'Client' } & ClientSchemaDefinition)
    | ({ type: 'Opportunity' } & OpporutnitySchemaDefinition);

  export type ClientSchemaDefinition = {
    summary: StringPropertyDefinition;
    details: StringPropertyDefinition;
    createdDate: StringPropertyDefinition;
  };

  export type OpporutnitySchemaDefinition = {
    summary: OpportunitySchema.StringPropertyDefinition;
    details: OpportunitySchema.StringPropertyDefinition;
    submit: OpportunitySchema.StringPropertyDefinition;
    createdDate: OpportunitySchema.StringPropertyDefinition;
  };

  export function mapClientSchemaToDefinition(
    schema: ClientSchemaDefinition
  ): Definition {
    return {
      ...schema,
      type: 'Client'
    };
  }

  export function mapOpportunitySchemaToDefinition(
    schema: OpporutnitySchemaDefinition
  ): Definition {
    return {
      ...schema,
      type: 'Opportunity'
    };
  }

  export type SchemaContract = {
    id: string;
    summary?: string;
    details?: string | null;
    submit?: boolean | null;
    createdDate?: string | null;
  };

  export type Model = {
    id: string;
    summary: string;
    details: string | null;
    submit: boolean | null;
    createdDate: string | null;
  };

  export function toModel(c: SchemaContract): Model {
    return {
      id: c.id,
      summary: c.summary || '',
      details: c.details || null,
      submit: c.submit || null,
      createdDate: DatesUtil.getDateString(c.createdDate) || null
    };
  }
}
